"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 15 15';

var CheckboxOn = function CheckboxOn() {
  return _react["default"].createElement("path", {
    d: "M11.745,3.5735 C10.5045,5.2555 7.905,10.232 6.903,12.381 C6.7935,12.6175 6.5565,12.768 6.297,12.768 C6.2915,12.768 6.286,12.768 6.2805,12.7675 C6.015,12.761 5.778,12.598 5.6775,12.352 C5.228,11.2525 3.795,8.9625 3.3595,8.6425 C3.0425,8.507 2.877,8.149 2.987,7.816 C3.104,7.4655 3.482,7.2755 3.8335,7.392 C4.526,7.622 5.596,9.341 6.2815,10.5915 C7.492,8.1495 9.539,4.3105 10.668,2.7795 C10.8875,2.4815 11.306,2.419 11.6035,2.638 C11.901,2.857 11.964,3.276 11.745,3.5735 M13.7715,0.5 L1.504,0.5 C0.949,0.5 0.5,0.9495 0.5,1.5035 L0.5,13.7715 C0.5,14.326 0.949,14.775 1.504,14.775 L13.7715,14.775 C14.3255,14.775 14.7755,14.326 14.7755,13.7715 L14.7755,1.5035 C14.7755,0.9495 14.3255,0.5 13.7715,0.5"
  });
};

var _default = (0, _createSvgIcon["default"])(CheckboxOn, {
  viewBox: viewBox
});

exports["default"] = _default;